/**
 *
 * @module telemetryClientConfiguration
 *
 */

import ServiceClientConfiguration from './../../configuration/serviceClientConfiguration';

/**
 *
 * @class TelemetryClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc Provides configuration information used by the TelemetryClient
 *
 */
export default class TelemetryClientConfiguration extends ServiceClientConfiguration {}



// WEBPACK FOOTER //
// ./src/services/internal/telemetry/telemetryClientConfiguration.js